const m = window.require("discourse/lib/computed");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;